import { render, staticRenderFns } from "./CreditsSettings.vue?vue&type=template&id=e5fcbadc&scoped=true"
import script from "./CreditsSettings.vue?vue&type=script&lang=ts"
export * from "./CreditsSettings.vue?vue&type=script&lang=ts"
import style0 from "./CreditsSettings.vue?vue&type=style&index=0&id=e5fcbadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fcbadc",
  null
  
)

export default component.exports